import { render, staticRenderFns } from "./Safe.vue?vue&type=template&id=167d0cbd"
import script from "./Safe.vue?vue&type=script&lang=js"
export * from "./Safe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports